import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  width: 90%;
  text-align: left;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateY(-100px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const Title = styled.h2`
  color: #e74c3c;
  margin-bottom: 20px;
  font-size: 24px;
  text-align: center;
`;

const Message = styled.div`
  color: #2c3e50;
  margin-bottom: 25px;
  font-size: 16px;
  line-height: 1.5;
`;

const MessageList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 15px 0;
  
  li {
    padding: 8px 0;
    margin: 5px 0;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    
    &:before {
      content: "•";
      color: #e74c3c;
      font-weight: bold;
      margin-right: 10px;
    }
    
    &:last-child {
      border-bottom: none;
    }
  }
`;

const Button = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: block;
  margin: 0 auto;
  width: 50%;
  min-width: 120px;

  &:hover {
    background-color: #c0392b;
  }
`;

const AlertModal = ({ message, onClose }) => {
  // Check if the message contains a list of fields
  const hasFieldList = message.includes(':');
  const [headerText, fieldList] = hasFieldList ? message.split(':') : [message, ''];
  const fields = fieldList.split(',').filter(field => field.trim());

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <Title>Uyarı</Title>
        {hasFieldList ? (
          <>
            <Message>{headerText}:</Message>
            <MessageList>
              {fields.map((field, index) => (
                <li key={index}>{field.trim()}</li>
              ))}
            </MessageList>
          </>
        ) : (
          <Message>{message}</Message>
        )}
        <Button onClick={onClose}>Tamam</Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AlertModal; 